import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as subawardMonitoringActivityAssignments from '../../subaward-monitoring-activity-assignments'

export const RESOURCE = {
  payload: {
    description: 'The association(s) between subaward and monitoring activity.',
    dimension: subawardMonitoringActivityAssignments.RESOURCE.payload,
    level: 0,
    name: 'Subaward Monitoring Activity Assignment',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
